import { render, staticRenderFns } from "./crm-create_patientHistoryType.vue?vue&type=template&id=50817f7d&"
import script from "./crm-create_patientHistoryType.vue?vue&type=script&lang=js&"
export * from "./crm-create_patientHistoryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports